import { render, staticRenderFns } from "./ShippingProblem.vue?vue&type=template&id=190ba0c2&"
import script from "./ShippingProblem.vue?vue&type=script&lang=js&"
export * from "./ShippingProblem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports